import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center fixed inset-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", { class: "icon button__icon stroke-2" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#close-small" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "absolute inset-0 sm:relative sm:aspect-[9/16] sm:w-full sm:max-w-sm sm:shadow-md sm:border sm:border-black/10 sm:rounded-2xl overflow-hidden mx-auto" }
const _hoisted_5 = {
  key: 0,
  class: "absolute inset-0 z-50 bg-black/80 flex justify-center items-center backdrop-blur"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-32 h-32" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/loader-new.gif",
    alt: "Loading...",
    role: "status"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "absolute inset-0 z-50 bg-black/80 flex flex-col text-white justify-center items-center backdrop-blur p-8 gap-4 text-center"
}
const _hoisted_9 = { class: "text-lg font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InactiveComponent = _resolveComponent("InactiveComponent")!
  const _component_VideoComponent = _resolveComponent("VideoComponent")!
  const _component_CSATComponent = _resolveComponent("CSATComponent")!
  const _component_NPSComponent = _resolveComponent("NPSComponent")!
  const _component_PromptComponent = _resolveComponent("PromptComponent")!
  const _component_RecordComponent = _resolveComponent("RecordComponent")!
  const _component_DetailsComponent = _resolveComponent("DetailsComponent")!
  const _component_SuccessComponent = _resolveComponent("SuccessComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.inAppPresentation)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.sdkClose()), ["prevent"])),
          class: "button button--circle fixed top-4 right-4 z-50 bg-creation-on-background/creation-low text-creation-on-background backdrop-blur-xl sm:bg-black/5 sm:text-black"
        }, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('creation.errorMessage')), 1),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
              role: "button",
              tabindex: "0",
              class: "button button--white"
            }, _toDisplayString(_ctx.$t('creation.tryAgainButtonLabel')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isInactive && _ctx.campaign)
        ? (_openBlock(), _createBlock(_component_InactiveComponent, {
            key: 2,
            campaign: _ctx.campaign
          }, null, 8, ["campaign"]))
        : _createCommentVNode("", true),
      (_ctx.campaign && _ctx.contribution)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (_ctx.isVideo)
                  ? (_openBlock(), _createBlock(_component_VideoComponent, {
                      key: 0,
                      campaign: _ctx.campaign,
                      contribution: _ctx.contribution,
                      onGoToNextScreen: _ctx.goToNextScreenFromVideoPreRoll
                    }, null, 8, ["campaign", "contribution", "onGoToNextScreen"]))
                  : (_ctx.isCSAT)
                    ? (_openBlock(), _createBlock(_component_CSATComponent, {
                        key: 1,
                        campaign: _ctx.campaign,
                        contribution: _ctx.contribution,
                        onSetContributionRating: _ctx.setContributionRating,
                        onGoToPromptScreen: _ctx.goToPromptScreen
                      }, null, 8, ["campaign", "contribution", "onSetContributionRating", "onGoToPromptScreen"]))
                    : (_ctx.isNPS)
                      ? (_openBlock(), _createBlock(_component_NPSComponent, {
                          key: 2,
                          contribution: _ctx.contribution,
                          campaign: _ctx.campaign,
                          onSetContributionRating: _ctx.setContributionRating,
                          onGoToPromptScreen: _ctx.goToPromptScreen
                        }, null, 8, ["contribution", "campaign", "onSetContributionRating", "onGoToPromptScreen"]))
                      : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.isPrompt)
              ? (_openBlock(), _createBlock(_component_PromptComponent, {
                  key: 0,
                  campaign: _ctx.campaign,
                  isRecordingPossible: _ctx.isRecordingPossible,
                  recordingDeniedReason: _ctx.recordingDeniedReason,
                  onRecordingRequested: _ctx.recordingRequestedEvent,
                  onGoBack: _ctx.goBack
                }, null, 8, ["campaign", "isRecordingPossible", "recordingDeniedReason", "onRecordingRequested", "onGoBack"]))
              : (_ctx.isRecord)
                ? (_openBlock(), _createBlock(_component_RecordComponent, {
                    key: `recorder-${_ctx.conversationRoundIndex}`,
                    contribution: _ctx.contribution,
                    recorder: _ctx.recorder,
                    campaign: _ctx.campaign,
                    "prompt-text": _ctx.currentQuestion,
                    conversationRoundIndex: _ctx.conversationRoundIndex,
                    onRecorderDataUpdated: _ctx.recorderDataUpdated,
                    onGoToToNextScreen: _ctx.goNextFromRecorder,
                    onGoToPromptScreen: _ctx.goBackFromRecorder
                  }, null, 8, ["contribution", "recorder", "campaign", "prompt-text", "conversationRoundIndex", "onRecorderDataUpdated", "onGoToToNextScreen", "onGoToPromptScreen"]))
                : (_ctx.isDetails)
                  ? (_openBlock(), _createBlock(_component_DetailsComponent, {
                      key: 2,
                      contribution: _ctx.contribution,
                      campaign: _ctx.campaign,
                      onSetImageData: _ctx.setImageData,
                      onSetImageURL: _ctx.setImageURL,
                      onTryToSubmit: _ctx.tryToSubmit,
                      onSetName: _ctx.setName,
                      onSetEmail: _ctx.setEmail,
                      onGoToRecordingScreen: _ctx.goToRecordingScreen
                    }, null, 8, ["contribution", "campaign", "onSetImageData", "onSetImageURL", "onTryToSubmit", "onSetName", "onSetEmail", "onGoToRecordingScreen"]))
                  : (_ctx.isSuccess)
                    ? (_openBlock(), _createBlock(_component_SuccessComponent, {
                        key: 3,
                        contribution: _ctx.contribution,
                        campaign: _ctx.campaign
                      }, null, 8, ["contribution", "campaign"]))
                    : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}